/**
 * Finds a business entity or nested item by ID.
 * Returns the entity/item and its items array for use in select inputs.
 * First checks root-level entities, then searches nested items.
 */
export function findEntityById(
  businessEntities: BusinessEntity[],
  id: string
): { items: { id: string; name: string; items?: { id: string; name: string }[] }[] } | null {
  // First check root-level entities
  const rootEntity = businessEntities.find(be => be.id === id);
  if (rootEntity) {
    return { items: rootEntity.items };
  }

  // Then check nested items
  for (const entity of businessEntities) {
    for (const item of entity.items) {
      if (item.id === id) {
        // If this nested item has its own items array, use that
        // Otherwise, return empty array (item has no sub-items)
        return { items: item.items ?? [] };
      }
    }
  }

  return null;
}
